import { request } from '@/src/oauth'

export default async function getCaregiversAvailableInPostcode(postcode) {
    const { data } = await request.get(
        `landing-page/caregivers-available/${postcode}`,
    )

    return data
}
